module.exports = __webpack_public_path__ + "static/media/sudoku3.e85bf12b.png";